import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  ArrowRight, Award, Star, CheckCircle, Send, MessageCircle, Calendar,
  Dog, GraduationCap, UserCheck, Trophy, ShieldCheck, Phone, MapPin,
  Cable, Repeat, Users, Home, Ear, Zap, Wind, Brain, ClipboardList, Facebook, Instagram
} from "lucide-react";

const WA = "https://wa.me/48663746095";

const HERO_IMG = "https://images.pexels.com/photos/9313625/pexels-photo-9313625.jpeg?auto=compress&cs=tinysrgb&w=1400";
const TRUST_IMG = "https://images.pexels.com/photos/13918163/pexels-photo-13918163.jpeg?auto=compress&cs=tinysrgb&w=1000";
const EXAM_IMG = "https://images.unsplash.com/photo-1617181668756-68f6613051d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";
const CTA_IMG = "https://images.unsplash.com/photo-1649923625148-1e13d9431053?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const OFFERS = [
  { icon: Dog, title: "SZKOLENIE SZCZENIĄT", text: "Prawidłowy start, socjalizacja, podstawy współpracy i budowanie pewności siebie.", img: "https://images.unsplash.com/photo-1619980296991-5c0d64b23950?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { icon: GraduationCap, title: "POSŁUSZEŃSTWO PODSTAWOWE", text: "Nauka komend, skupienie, chodzenie na luźnej smyczy, kontrola emocji i codzienna współpraca.", img: "https://images.pexels.com/photos/13918163/pexels-photo-13918163.jpeg?auto=compress&cs=tinysrgb&w=800" },
  { icon: UserCheck, title: "KONSULTACJE INDYWIDUALNE", text: "Indywidualny plan szkolenia dopasowany do potrzeb psa i oczekiwań właściciela.", img: "https://images.pexels.com/photos/9313625/pexels-photo-9313625.jpeg?auto=compress&cs=tinysrgb&w=800" },
  { icon: Trophy, title: "PRZYGOTOWANIE DO EGZAMINÓW", text: "Przygotowanie do BH-VT, IGP, prób pracy, testów psychicznych i przeglądów hodowlanych.", img: "https://images.unsplash.com/photo-1775727608028-06463000662d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { icon: Award, title: "HANDLING WYSTAWOWY", text: "Przygotowanie do wystaw, nauka prezentacji w ringu, ruchu i współpracy z przewodnikiem.", img: "https://images.unsplash.com/photo-1649571069618-99a265749d5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { icon: ShieldCheck, title: "TRENING OWCZARKÓW NIEMIECKICH", text: "Specjalistyczne szkolenie dostosowane do potrzeb rasy i charakteru.", img: "https://images.unsplash.com/photo-1553882809-a4f57e59501d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
];

const PROBLEMS = [
  { icon: Cable, label: "Pies ciągnie\nna smyczy" },
  { icon: Repeat, label: "Nie wraca\nna przywołanie" },
  { icon: Users, label: "Skacze\nna ludzi" },
  { icon: Home, label: "Nie potrafi zostać\nsam w domu" },
  { icon: Ear, label: "Nie słucha\nkomend" },
  { icon: Zap, label: "Nadmiernie się\nekscytuje" },
  { icon: Wind, label: "Strach, lęk,\nniepewność" },
];

const EXAMS = [
  { icon: ShieldCheck, label: "BH-VT" },
  { icon: Dog, label: "IGP" },
  { icon: Trophy, label: "Próby pracy" },
  { icon: Brain, label: "Testy\npsychiczne" },
  { icon: ClipboardList, label: "Przeglądy\nhodowlane" },
];

const TRUST = [
  "Wieloletnie doświadczenie w pracy z psami",
  "Metody oparte na zrozumieniu i budowaniu relacji",
  "Specjalizacja w rasach użytkowych, szczególnie w owczarkach niemieckich",
  "Przygotowanie do życia codziennego, sportu i pracy",
  "Indywidualne podejście do każdego psa i przewodnika",
  "Wsparcie właściciela na każdym etapie",
];

// PLACEHOLDER — opinie pod szkolenia (do podmiany przez klientkę)
const TESTIMONIALS = [
  { name: "Kasia i Hugo", text: "Dzięki szkoleniu w Wolfe vom Katzenberg nasz Hugo stał się spokojniejszy, pewniejszy i dużo lepiej się z nami komunikuje. Profesjonalizm i super atmosfera!", img: "https://images.unsplash.com/photo-1575785662490-1e3ce6806ed5?crop=entropy&cs=srgb&fm=jpg&q=85&w=400" },
  { name: "Marek i Nala", text: "Przygotowanie do BH-VT na najwyższym poziomie. Instruktorzy znają się na rzeczy i potrafią świetnie zmotywować zarówno psa, jak i przewodnika.", img: "https://images.pexels.com/photos/13711974/pexels-photo-13711974.jpeg?auto=compress&cs=tinysrgb&w=400" },
  { name: "Anna i Rex", text: "Indywidualne podejście, ogromna wiedza i cierpliwość. Rex robi ogromne postępy, a my wreszcie rozumiemy, jak z nim pracować. Polecamy!", img: "https://images.unsplash.com/photo-1649923625148-1e13d9431053?crop=entropy&cs=srgb&fm=jpg&q=85&w=400" },
];

// PLACEHOLDER — artykuły SEO (treści pisze klientka)
const ARTICLES = [
  { title: "Kiedy rozpocząć szkolenie szczeniaka?", img: "https://images.unsplash.com/photo-1648495333000-32689c4ead62?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { title: "Jak nauczyć psa przywołania?", img: "https://images.unsplash.com/photo-1619980263701-ff2df2e12423?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { title: "10 najczęstszych błędów właścicieli psów", img: "https://images.unsplash.com/photo-1650219913416-fe9977dc5828?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { title: "Dlaczego owczarek niemiecki potrzebuje szkolenia?", img: "https://images.unsplash.com/photo-1734921696551-2ce47b5c12dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { title: "Jak przygotować dom na przyjęcie szczeniaka?", img: "https://images.pexels.com/photos/33159007/pexels-photo-33159007.jpeg?auto=compress&cs=tinysrgb&w=600" },
];

const fade = (d = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.6, delay: d },
});

const KennelTraining = () => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", type: "", dog: "", problem: "" });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    const text =
      `Dzień dobry! Chcę zapisać psa na szkolenie.\n\n` +
      `Imię i nazwisko: ${form.name || "—"}\n` +
      `Telefon: ${form.phone || "—"}\n` +
      `E-mail: ${form.email || "—"}\n` +
      `Rodzaj szkolenia: ${form.type || "—"}\n` +
      `Wiek i rasa psa: ${form.dog || "—"}\n` +
      `Opis problemu / potrzeb: ${form.problem || "—"}`;
    window.open(`${WA}?text=${encodeURIComponent(text)}`, "_blank", "noopener,noreferrer");
    setSent(true);
    setSending(false);
  };

  const inputCls = "w-full bg-[#9C8443]/40 border border-[#0B0B0D]/20 px-4 py-3 text-sm text-[#1A150A] placeholder:text-[#1A150A]/50 focus:bg-[#9C8443]/55 focus:outline-none transition-colors";

  return (
    <div className="bg-[#0B0B0D] text-[#F5F5F5] min-h-screen">
      {/* ── HEADER ── */}
      <header className="sticky top-0 z-50 bg-[#0B0B0D]/90 backdrop-blur-md border-b border-[#2A2A2D]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="training-logo">
            <img src="/logo_katzenberg_new.png" alt="Wolfe vom Katzenberg" className="h-12 w-auto drop-shadow-[0_0_12px_rgba(212,175,55,0.25)]" />
            <span className="hidden sm:block font-serif text-sm tracking-wider text-[#F5F5F5] leading-tight">
              WOLFE<br /><span className="text-[10px] tracking-[0.2em] text-[#B8B8B8]/60">VOM KATZENBERG · FCI</span>
            </span>
          </Link>
          <nav className="hidden lg:flex items-center gap-7 text-[11px] tracking-[0.18em] text-[#C8C8C8]">
            <Link to="/" className="hover:text-[#D4AF37] transition-colors">HODOWLA</Link>
            <Link to="/psy" className="hover:text-[#D4AF37] transition-colors">NASZE PSY</Link>
            <span className="text-[#D4AF37]">SZKOLENIA</span>
            <Link to="/mioty" className="hover:text-[#D4AF37] transition-colors">MIOTY</Link>
            <Link to="/o-hodowli" className="hover:text-[#D4AF37] transition-colors">O NAS</Link>
            <Link to="/kontakt" className="hover:text-[#D4AF37] transition-colors">KONTAKT</Link>
          </nav>
          <a href="#kontakt" data-testid="training-header-cta"
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#0B0B0D] px-5 py-2.5 text-[11px] font-bold tracking-[0.12em] hover:bg-[#C8A96A] transition-colors shrink-0">
            <Calendar className="w-4 h-4" /> <span className="hidden sm:inline">ZAPISZ SIĘ NA SZKOLENIE</span><span className="sm:hidden">ZAPISZ</span>
          </a>
        </div>
      </header>

      {/* ── HERO ── */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <video autoPlay loop muted playsInline poster={HERO_IMG}
            className="w-full h-full object-cover object-center">
            <source src="/szkolenia_hero.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-[#0B0B0D]/35" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B0B0D] via-[#0B0B0D]/80 to-[#0B0B0D]/30" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0D]/75 via-transparent to-[#0B0B0D]/45" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 min-h-[80vh] flex items-center">
          <motion.div {...fade()} className="max-w-2xl">
            <span className="font-serif text-sm sm:text-base tracking-[0.3em] text-[#D4AF37] block mb-4">WOLFE VOM KATZENBERG · FCI</span>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-wide mb-5 uppercase">
              Szkolenia <span className="text-[#D4AF37]">psów</span>
            </h1>
            <p className="font-serif text-xl md:text-2xl text-[#E8D7A0] mb-6">Wrocław i Dolny Śląsk</p>
            <p className="text-[#D4D4D4] text-sm md:text-base leading-relaxed mb-9 max-w-xl">
              Budujemy relacje oparte na zaufaniu, zrozumieniu i skutecznej komunikacji.
              Niezależnie od wieku i rasy — pomożemy Wam stworzyć zgrany zespół.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="#kontakt" data-testid="hero-signup-btn"
                className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#0B0B0D] px-8 py-4 text-xs font-bold tracking-[0.15em] hover:bg-[#C8A96A] transition-all hover:shadow-lg hover:shadow-[#D4AF37]/20">
                <Calendar className="w-4 h-4" /> ZAPISZ PSA NA SZKOLENIE
              </a>
              <a href="#oferta" data-testid="hero-offer-btn"
                className="inline-flex items-center justify-center gap-2 border border-[#D4AF37]/50 text-[#F5F5F5] px-8 py-4 text-xs font-bold tracking-[0.15em] hover:border-[#D4AF37] hover:bg-[#D4AF37]/5 transition-all">
                POZNAJ OFERTĘ
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── OFERTA (dark) ── */}
      <div id="oferta" />
      <section className="px-6 md:px-10 py-20 md:py-28 bg-[#0B0B0D]">
        <div className="max-w-[1400px] mx-auto">
          <motion.div {...fade()} className="text-center mb-14">
            <h2 className="font-serif text-[clamp(1.6rem,3vw,2.5rem)] tracking-[0.15em] text-[#D4AF37] uppercase">Nasza oferta</h2>
            <div className="w-16 h-px bg-[#D4AF37]/40 mx-auto mt-5" />
          </motion.div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-5">
            {OFFERS.map((o, i) => (
              <motion.div key={i} {...fade(i * 0.06)} data-testid={`offer-card-${i}`}
                className="group bg-[#141416] border border-[#2A2A2D] overflow-hidden hover:border-[#D4AF37]/40 transition-colors">
                <div className="relative">
                  <div className="relative h-40 overflow-hidden">
                    <img src={o.img} alt={o.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#141416] via-[#141416]/20 to-transparent" />
                  </div>
                  <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-[#141416] border border-[#D4AF37]/40 flex items-center justify-center z-10">
                    <o.icon className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                </div>
                <div className="p-5 pt-9 text-center">
                  <h3 className="font-serif text-sm text-[#F5F5F5] mb-3 tracking-wide leading-snug min-h-[40px] flex items-center justify-center">{o.title}</h3>
                  <p className="text-[#B8B8B8]/70 text-xs leading-relaxed mb-5">{o.text}</p>
                  <a href="#kontakt" className="inline-flex items-center gap-1.5 text-[#D4AF37] text-[10px] tracking-[0.12em] hover:gap-3 transition-all">
                    DOWIEDZ SIĘ WIĘCEJ <ArrowRight className="w-3 h-3" />
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROBLEMY (light) ── */}
      <section className="px-6 md:px-10 py-20 bg-[#F4EFE6]">
        <div className="max-w-7xl mx-auto">
          <motion.h2 {...fade()} className="font-serif text-[clamp(1.5rem,2.8vw,2.2rem)] tracking-[0.1em] text-[#1C1A15] uppercase text-center mb-14">
            Jakie problemy pomagamy rozwiązać?
          </motion.h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-6">
            {PROBLEMS.map((p, i) => (
              <motion.div key={i} {...fade(i * 0.05)} data-testid={`problem-${i}`} className="flex flex-col items-center text-center">
                <p.icon className="w-12 h-12 text-[#C8A04A] mb-4" strokeWidth={1.2} />
                <span className="text-[#3A352C] text-sm leading-snug whitespace-pre-line">{p.label}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── EGZAMINY (dark) ── */}
      <section className="bg-[#0B0B0D]">
        <div className="grid lg:grid-cols-[1fr_1.4fr]">
          <motion.div {...fade()} className="relative min-h-[320px] lg:min-h-full">
            <img src={EXAM_IMG} alt="Trening i egzaminy" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0B0B0D]/80" />
          </motion.div>
          <motion.div {...fade(0.1)} className="px-6 md:px-12 py-16 md:py-20">
            <h2 className="font-serif text-[clamp(1.5rem,2.8vw,2.2rem)] tracking-[0.1em] text-[#D4AF37] uppercase mb-8">Przygotowanie do egzaminów</h2>
            <p className="text-[10px] tracking-[0.25em] text-[#B8B8B8]/60 mb-6">PROFESJONALNE PRZYGOTOWANIE DO:</p>
            <div className="grid grid-cols-3 sm:grid-cols-5 gap-5 mb-9">
              {EXAMS.map((e, i) => (
                <div key={i} data-testid={`exam-${i}`} className="flex flex-col items-center text-center">
                  <e.icon className="w-9 h-9 text-[#D4AF37] mb-2" strokeWidth={1.3} />
                  <span className="text-[#E0E0E0] text-xs whitespace-pre-line">{e.label}</span>
                </div>
              ))}
            </div>
            <p className="text-[#B8B8B8] text-sm leading-relaxed mb-8 max-w-lg">
              Egzaminy i próby to nie tylko test umiejętności psa, ale również współpracy z przewodnikiem.
              Pomożemy Wam osiągnąć gotowość na każdym etapie.
            </p>
            <a href="#kontakt" data-testid="exams-cta"
              className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#0B0B0D] px-7 py-3.5 text-xs font-bold tracking-[0.15em] hover:bg-[#C8A96A] transition-colors">
              ZOBACZ SZCZEGÓŁY <ArrowRight className="w-4 h-4" />
            </a>
          </motion.div>
        </div>
      </section>

      {/* ── DLACZEGO WARTO (dark + watermark) ── */}
      <section className="relative px-6 md:px-10 py-20 md:py-28 bg-[#0B0B0D] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1553882809-a4f57e59501d?crop=entropy&cs=srgb&fm=jpg&q=85&w=600"
          alt="" className="pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 h-[80%] w-auto object-contain opacity-[0.06]" />
        <div className="relative max-w-7xl mx-auto grid lg:grid-cols-[0.85fr_1.15fr] gap-12 items-center">
          <motion.div {...fade()} className="relative h-72 lg:h-96 overflow-hidden border border-[#2A2A2D]">
            <img src={TRUST_IMG} alt="Trener z owczarkiem niemieckim" className="w-full h-full object-cover" />
          </motion.div>
          <motion.div {...fade(0.1)}>
            <h2 className="font-serif text-[clamp(1.5rem,2.8vw,2.2rem)] tracking-[0.08em] text-[#D4AF37] uppercase mb-9">Dlaczego warto nam zaufać?</h2>
            <div className="grid sm:grid-cols-2 gap-x-10 gap-y-5">
              {TRUST.map((t, i) => (
                <div key={i} data-testid={`trust-${i}`} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#D4AF37] shrink-0 mt-0.5" />
                  <span className="text-[#C8C8C8] text-sm leading-relaxed">{t}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── OPINIE (dark + light cards) ── */}
      <section className="px-6 md:px-10 py-20 md:py-24 bg-[#101012]">
        <div className="max-w-7xl mx-auto">
          <motion.h2 {...fade()} className="font-serif text-[clamp(1.5rem,2.8vw,2.2rem)] tracking-[0.1em] text-[#D4AF37] uppercase text-center mb-14">
            Opinie naszych klientów
          </motion.h2>
          <div className="grid md:grid-cols-3 gap-6">
            {TESTIMONIALS.map((r, i) => (
              <motion.div key={i} {...fade(i * 0.08)} data-testid={`training-review-${i}`}
                className="bg-[#F4EFE6] p-6 shadow-xl">
                <div className="flex items-center gap-3 mb-4">
                  <img src={r.img} alt={r.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#D4AF37]/40" />
                  <div>
                    <p className="text-[#1C1A15] text-sm font-bold">{r.name}</p>
                    <div className="flex gap-0.5 mt-1">
                      {[...Array(5)].map((_, s) => <Star key={s} className="w-3.5 h-3.5 text-[#D4AF37] fill-[#D4AF37]" />)}
                    </div>
                  </div>
                </div>
                <p className="text-[#4A4438] text-sm leading-relaxed">{r.text}</p>
              </motion.div>
            ))}
          </div>
          <div className="flex justify-center gap-2 mt-9">
            {[0, 1, 2].map(d => <span key={d} className={`w-2 h-2 rounded-full ${d === 0 ? "bg-[#D4AF37]" : "bg-[#D4AF37]/30"}`} />)}
          </div>
        </div>
      </section>

      {/* ── PORADNIK (light) ── */}
      <section className="px-6 md:px-10 py-20 bg-[#F4EFE6]">
        <div className="max-w-7xl mx-auto">
          <motion.div {...fade()} className="flex items-end justify-between mb-12 gap-4 flex-wrap">
            <h2 className="font-serif text-[clamp(1.4rem,2.6vw,2.1rem)] tracking-[0.06em] text-[#1C1A15] uppercase">Poradnik właściciela psa</h2>
            <span className="inline-flex items-center gap-1.5 text-[#9C7B2E] text-[11px] tracking-[0.12em] font-semibold">
              ZOBACZ WSZYSTKIE ARTYKUŁY <ArrowRight className="w-3.5 h-3.5" />
            </span>
          </motion.div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
            {ARTICLES.map((a, i) => (
              <motion.article key={i} {...fade(i * 0.06)} data-testid={`article-${i}`}
                className="group bg-white shadow-md overflow-hidden hover:shadow-xl transition-shadow">
                <div className="h-36 overflow-hidden">
                  <img src={a.img} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-4">
                  <h3 className="text-[#1C1A15] text-sm font-semibold leading-snug mb-3 min-h-[40px]">{a.title}</h3>
                  <span className="inline-flex items-center gap-1.5 text-[#9C7B2E] text-[10px] tracking-[0.12em] font-semibold">
                    DOWIEDZ SIĘ WIĘCEJ <ArrowRight className="w-3 h-3" />
                  </span>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA / KONTAKT (dark, dog left + gold form right) ── */}
      <section id="kontakt" className="relative bg-[#0B0B0D]">
        <div className="grid lg:grid-cols-2">
          {/* Left: dog + copy */}
          <div className="relative min-h-[340px] lg:min-h-full flex items-center">
            <img src={CTA_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0B0B0D]/70 to-[#0B0B0D]/90" />
            <motion.div {...fade()} className="relative px-6 md:px-12 py-16">
              <span className="text-[10px] tracking-[0.35em] text-[#D4AF37] block mb-4">GOTOWY NA ZMIANĘ?</span>
              <h2 className="font-serif text-[clamp(1.8rem,3.5vw,2.8rem)] text-[#F5F5F5] mb-4">Zapisz psa na szkolenie</h2>
              <p className="text-[#B8B8B8]/80 text-sm mb-8 max-w-md">Skontaktuj się z nami i sprawdź dostępne terminy.</p>
              <div className="space-y-3 text-sm text-[#C8C8C8] mb-8">
                <div className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#D4AF37]" /> Wrocław i okolice · Dolny Śląsk</div>
                <a href="tel:+48663746095" className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors"><Phone className="w-4 h-4 text-[#D4AF37]" /> +48 663 746 095</a>
                <a href={WA} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[#25D366] transition-colors"><MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp</a>
              </div>
              <a href={WA} target="_blank" rel="noopener noreferrer" data-testid="training-whatsapp-btn"
                className="inline-flex items-center gap-2.5 bg-[#25D366] text-white px-7 py-3.5 text-sm font-medium hover:bg-[#20BA5A] transition-colors">
                <MessageCircle className="w-5 h-5" /> Napisz na WhatsApp
              </a>
            </motion.div>
          </div>

          {/* Right: gold form panel */}
          <div className="bg-gradient-to-br from-[#C9A94F] to-[#B8973F] px-6 md:px-12 py-16 flex items-center">
            <div className="w-full max-w-lg mx-auto">
              <h3 className="font-serif text-xl tracking-[0.12em] text-[#1A150A] uppercase text-center mb-8">Zapytanie o szkolenie</h3>
              {sent ? (
                <div className="bg-[#1A150A]/10 border border-[#1A150A]/20 p-10 text-center" data-testid="training-form-success">
                  <MessageCircle className="w-10 h-10 text-[#1A150A] mx-auto mb-4" />
                  <h4 className="font-serif text-lg text-[#1A150A] mb-2">Otwieramy WhatsApp…</h4>
                  <p className="text-[#1A150A]/70 text-sm">Twoje zgłoszenie zostało przygotowane jako gotowa wiadomość — wystarczy ją wysłać. Jeśli okno się nie otworzyło, kliknij „Napisz na WhatsApp".</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} data-testid="training-form" className="grid sm:grid-cols-2 gap-4">
                  <input required placeholder="Imię i nazwisko" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} data-testid="training-name" className={`${inputCls} sm:col-span-2`} />
                  <input placeholder="Telefon" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} data-testid="training-phone" className={inputCls} />
                  <input type="email" placeholder="E-mail" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} data-testid="training-email" className={inputCls} />
                  <input placeholder="Jakiego szkolenia szukasz?" value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} data-testid="training-type" className={inputCls} />
                  <input placeholder="Wiek i rasa psa" value={form.dog} onChange={e => setForm({ ...form, dog: e.target.value })} data-testid="training-dog" className={inputCls} />
                  <textarea rows="4" placeholder="Opisz problem / potrzeby" value={form.problem} onChange={e => setForm({ ...form, problem: e.target.value })} data-testid="training-problem" className={`${inputCls} sm:col-span-2 resize-none`} />
                  <button type="submit" disabled={sending} data-testid="training-submit"
                    className="sm:col-span-2 py-3.5 bg-[#1A150A] text-[#E8D7A0] text-xs font-bold tracking-[0.2em] hover:bg-[#000] transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
                    {sending ? "WYSYŁANIE..." : <><Send className="w-4 h-4" /> WYŚLIJ ZAPYTANIE</>}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="bg-[#0B0B0D] border-t border-[#2A2A2D]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src="/logo_katzenberg_new.png" alt="Wolfe vom Katzenberg" className="h-11 w-auto" />
            <div className="text-xs text-[#B8B8B8]/60 leading-relaxed">
              <p className="text-[#F5F5F5] font-serif tracking-wide">WOLFE VOM KATZENBERG · FCI</p>
              <p className="text-[10px] tracking-[0.18em] text-[#B8B8B8]/40">HODOWLA · SZKOLENIE z PASJĄ</p>
            </div>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] tracking-[0.16em] text-[#C8C8C8]">
            <Link to="/" className="hover:text-[#D4AF37] transition-colors">HODOWLA</Link>
            <Link to="/psy" className="hover:text-[#D4AF37] transition-colors">NASZE PSY</Link>
            <span className="text-[#D4AF37]">SZKOLENIA</span>
            <Link to="/mioty" className="hover:text-[#D4AF37] transition-colors">MIOTY</Link>
            <Link to="/o-hodowli" className="hover:text-[#D4AF37] transition-colors">O NAS</Link>
            <Link to="/kontakt" className="hover:text-[#D4AF37] transition-colors">KONTAKT</Link>
          </nav>
          <div className="flex items-center gap-3">
            <a href="https://www.facebook.com/profile.php?id=61593187978675" target="_blank" rel="noopener noreferrer"
              className="w-9 h-9 rounded-full border border-[#2A2A2D] flex items-center justify-center text-[#B8B8B8] hover:text-[#D4AF37] hover:border-[#D4AF37]/40 transition-colors" aria-label="Facebook">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"
              className="w-9 h-9 rounded-full border border-[#2A2A2D] flex items-center justify-center text-[#B8B8B8] hover:text-[#D4AF37] hover:border-[#D4AF37]/40 transition-colors" aria-label="Instagram">
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>
        <div className="border-t border-[#2A2A2D]/60 py-5">
          <p className="text-center text-[10px] text-[#B8B8B8]/30 tracking-wider">
            © 2026 Wolfe vom Katzenberg · FCI. Wszelkie prawa zastrzeżone.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default KennelTraining;
